export default __webpack_public_path__ + "static/media/wolverine.f0d53702.png";